module.exports = __webpack_public_path__ + "img/UserExperience.418730cb.jpg";